import { RouteRecordRaw } from 'vue-router'

const Servicedetail = () => import('@/views/serviceorder/servicedetail/ServiceDetail.vue')
const Serviceappeal = () => import('@/views/serviceorder/serviceappeal/ServiceAppeal.vue')
const Selectdate = () => import('@/views/serviceorder/selectdate/SelectDate.vue')
const Repairorder = () => import('@/views/serviceorder/repairorder/RepairOrder.vue')
const Reserveorder = () => import('@/views/serviceorder/reserveorder/ReserveOrder.vue')
const Chooseaddress = () => import('@/views/serviceorder/chooseaddress/ChooseAddress.vue')
const Checkdetail = () => import('@/views/serviceorder/checkdetail/CheckDetail.vue')
const Buyusetime = () => import('@/views/serviceorder/buyusetime/BuyUseTime.vue')
const Afterpay = () => import('@/views/serviceorder/afterpay/AfterPay.vue')
const Protoc = () => import('@/views/serviceorder/protoc/Protoc.vue')
const Servicevaluate = () => import('@/views/serviceorder/servicevaluate/servicevaluate.vue')
const routes: Array<RouteRecordRaw> = [
  {
    path: '/servicedetail/:guid',
    name: 'servicedetail',
    component: Servicedetail,
  },
  {
    path: '/serviceappeal/:sn/:guid/:type',
    name: 'serviceappeal',
    component: Serviceappeal,
  },
  {
    path: '/selectdate/:sn/:guid/:type',
    name: 'selectdate',
    component: Selectdate,
  },
  {
    path: '/repairorder/:guid',
    name: 'repairorder',
    component: Repairorder,
  },
  {
    path: '/reserveorder/:guid',
    name: 'reserveorder',
    component: Reserveorder,
  },
  {
    path: '/chooseaddress/:guid',
    name: 'chooseaddress',
    component: Chooseaddress,
  },
  {
    path: '/checkdetail/:guid',
    name: 'checkdetail',
    component: Checkdetail,
  },
  {
    path: '/buyusetime/:sn/:guid',
    name: 'Buyusetime',
    component: Buyusetime,
  },
  {
    path: '/afterpay/:type/:sn/:guid/:amount',
    name: 'afterpay',
    component: Afterpay,
  },
  {
    path: '/protoc',
    name: 'protoc',
    component: Protoc,
  },
  {
    path: '/servicevaluate',
    name: 'servicevaluate',
    component: Servicevaluate,
  },
]
export default routes
